/**
 * Query-string and path primitives shared by API URLs and app URLs.
 * The serializer itself lives in @web-v4/api-client (it owns the wire
 * shape of API query strings); re-used here so both URL kinds encode
 * identically — there is exactly one query serializer in the monorepo.
 */
import { serializeQuery } from '@web-v4/api-client';
/** Appends a query string to a path; null/undefined values are dropped, arrays repeated. */
export function withQuery(path, query) {
    const qs = query ? serializeQuery(query) : '';
    return qs ? `${path}?${qs}` : path;
}
function ensureLeadingSlash(path) {
    return path.startsWith('/') ? path : `/${path}`;
}
/**
 * Joins a base path and a suffix without doubling or dropping slashes:
 *
 *   joinPaths('/',      '/login')   → '/login'
 *   joinPaths('/user',  '/tickets') → '/user/tickets'
 *   joinPaths('/user',  '')         → '/user'
 *   joinPaths('/user',  '/')        → '/user/'
 */
export function joinPaths(base, path = '') {
    const suffix = path === '' ? '' : ensureLeadingSlash(path);
    if (base === '' || base === '/') {
        return suffix === '' ? '/' : suffix;
    }
    return `${base}${suffix}`;
}
//# sourceMappingURL=url.js.map